import { createFileRoute } from "@tanstack/react-router";
import GeneradorWhatsapp from "../pages/GeneradorWhatsapp";

export const Route = createFileRoute("/generador-link-whatsapp")({
  component: GeneradorWhatsapp,
});
